import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d6b6f87"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'OverlayButton',
  props: {
  disabled: Boolean,
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "overlay-button",
    disabled: props.disabled,
    onClick: _cache[0] || (_cache[0] = e => emit('click', e))
  }, null, 8, _hoisted_1))
}
}

})